export default __webpack_public_path__ + "static/service-shape3-073103366f10c07e6e71ac241ef4631f.png";